import { render, staticRenderFns } from "./PickupLocationForm.vue?vue&type=template&id=64e0b1d8&scoped=true"
import script from "./PickupLocationForm.vue?vue&type=script&lang=js"
export * from "./PickupLocationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e0b1d8",
  null
  
)

export default component.exports